import React, { useEffect, useState } from 'react'
import { Modal, Row, Typography, Space, Image, Spin } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { commonUtils } from '@/helpers/commonUtils'
import styles from './LoginModal.module.less'
import { api } from '@/helpers/api'
import { userService } from '@/services/userService'

const { Title, Text } = Typography

export interface LoginModalProps {
  visible: boolean
  type?: 'login' | 'contact'
  onClose?: () => void
  onLoginSuccess?: () => void
}

let timer: any = null
const LoginModal: React.FC<LoginModalProps> = ({ visible, onLoginSuccess, type, onClose }) => {
  const [qrCode, setQrCode] = useState('')

  const onCancel = () => {
    stopCheck()
    onClose?.()
  }

  const stopCheck = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  const checkLoginStatus = async (state: string) => {
    if (!visible || type === 'contact') {
      return
    }
    const {
      data: { login },
    } = await api.user.confirmH5LoginStatus(state)
    if (login) {
      await userService.getUserInfo()
      onLoginSuccess?.()
      const params = userService.getLoginParams()
      userService.postUserActionRecord({
        module: 'PC端官网',
        function: '登录弹窗',
        position: '登录成功',
        action: '展示',
        element: '页面',
        remark: params,
      })
      userService.removeUtmInfo()
      onCancel()
    } else {
      timer = setTimeout(() => {
        checkLoginStatus(state)
      }, 1000)
    }
  }

  const getLoginQrCode = async () => {
    const params = userService.getLoginParams()
    const {
      data: { imageUrl, state },
    } = await api.user.getLoginQrCode(params)
    setQrCode(imageUrl)
    checkLoginStatus(state)
  }
  useEffect(() => {
    stopCheck()
    if (visible) {
      if (type === 'contact') {
        userService.postUserActionRecord({
          module: 'PC端官网',
          function: '领取课件弹窗',
          position: '领取课件客服二维码',
          action: '展示',
          element: '弹窗',
          remark: {
            url: window.location.href,
            source: userService.getUserSource(),
          },
        })
        return
      }
      getLoginQrCode()
      userService.postUserActionRecord({
        module: 'PC端官网',
        function: '登录弹窗',
        position: '触发登录弹窗',
        action: '展示',
        element: '页面',
      })
    }
    return () => {
      stopCheck()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])
  return (
    <Modal
      open={visible}
      footer={null}
      closable={true}
      closeIcon={<CloseOutlined />}
      onCancel={onCancel}
      width={768}
      height={543}
      centered
      title={null}
      style={{ borderRadius: 12 }}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          padding: 0,
          overflow: 'hidden',
          borderRadius: 28,
        },
      }}
    >
      <Row>
        {/* 左侧内容 */}
        <div
          style={{
            padding: '35px 0 0 65px',
            background: '#FFF8E9',
            position: 'relative',
            width: 325,
          }}
          className={styles.leftContent}
        >
          <img
            className={styles.icon1}
            src={commonUtils.getStaticFile('pc/icon__login-circle-1.png')}
            alt='icon__login-circle-1'
          />
          <img
            className={styles.icon2}
            src={commonUtils.getStaticFile('pc/icon__login-circle-2.png')}
            alt='icon__login-circle-2'
          />

          <div style={{ marginBottom: 37 }}>
            <Image
              src={commonUtils.getStaticFile('logo-new.png')}
              alt='一起课件'
              preview={false}
              width={111}
            />
          </div>

          <div className={styles.leftContentTitle}>
            <img
              src={commonUtils.getStaticFile('pc/title__login-modal.png')}
              alt='title__login-modal'
            />
          </div>

          <Space direction='vertical' size={32}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                className={styles.iconGet}
                src={commonUtils.getStaticFile('pc/icon__login-get.png')}
                alt='pc/icon__login-get'
              />
              <Text
                style={{
                  fontWeight: 400,
                  fontSize: 19,
                  color: 'rgba(0,0,0,0.65)',
                  lineHeight: 'normal',
                }}
              >
                专业资深教研团队
              </Text>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                className={styles.iconGet}
                src={commonUtils.getStaticFile('pc/icon__login-get.png')}
                alt='pc/icon__login-get'
              />
              <Text
                style={{
                  fontWeight: 400,
                  fontSize: 19,
                  color: 'rgba(0,0,0,0.65)',
                  lineHeight: 'normal',
                }}
              >
                教育美学设计标准
              </Text>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                className={styles.iconGet}
                src={commonUtils.getStaticFile('pc/icon__login-get.png')}
                alt='pc/icon__login-get'
              />
              <Text
                style={{
                  fontWeight: 400,
                  fontSize: 19,
                  color: 'rgba(0,0,0,0.65)',
                  lineHeight: 'normal',
                }}
              >
                快速响应教材更新
              </Text>
            </div>
          </Space>

          <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
            <Image
              src={commonUtils.getStaticFile('pc/bg__login-modal.png')}
              preview={false}
              width='100%'
            />
          </div>
        </div>

        {/* 右侧二维码 */}
        <div className={styles.rightContent}>
          <Title level={3} style={{ marginBottom: 16 }}>
            {type === 'contact' ? '领取课件' : '登录'}
          </Title>

          {type !== 'contact' ? (
            <Text
              style={{
                marginBottom: 24,
                fontWeight: 400,
                fontSize: 16,
                color: 'rgba(0,0,0,0.75)',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img
                src={commonUtils.getStaticFile('wechat-green.png')}
                style={{ width: 16, marginRight: 4 }}
                alt='微信'
              />
              请使用微信扫码
            </Text>
          ) : (
            <Text
              style={{
                marginBottom: 24,
                fontWeight: 400,
                fontSize: 16,
                color: 'rgba(0,0,0,0.75)',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img
                style={{ width: 18, marginRight: 4 }}
                className={styles.star}
                src={commonUtils.getStaticFile('images/star.png')}
                draggable={false}
              />
              添加客服领取课件～
            </Text>
          )}
          <div
            style={{
              padding: '10px',
              marginBottom: 20,
              background: '#FFFFFF',
              borderRadius: 4,
              border: '1px solid #EEEEEE',
              width: 267,
              height: 267,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {type === 'contact' ? (
              <img src={userService.getContactQrUrl('pc')} alt='pc' />
            ) : (
              <Spin spinning={!qrCode} size='small'>
                {qrCode && (
                  <Image src={qrCode} alt='微信二维码' preview={false} width={245} height={245} />
                )}
              </Spin>
            )}
          </div>

          {type !== 'contact' ? (
            <Text type='secondary'>微信扫码即可登录</Text>
          ) : (
            <Text
              style={{
                marginBottom: 24,
                fontWeight: 400,
                fontSize: 16,
                color: 'rgba(0,0,0,0.75)',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img
                src={commonUtils.getStaticFile('wechat-green.png')}
                style={{ width: 16, marginRight: 4 }}
                alt='微信'
              />
              请使用微信扫码
            </Text>
          )}
        </div>
      </Row>
    </Modal>
  )
}

export default LoginModal
